<template>
  <fragment>
    <transition mode="out-in">
      <div class="col-12" v-if="detalhe">
        <a href="#" class="btn-voltar d-print-none" @click="detalhe = false">
          <span class="material-icons">chevron_left</span> Lista de Faturas
        </a>
        <h1 class="title mt-4 text-uppercase">
          EXTRATO DA FATURA {{ this.nNota }}
        </h1>
        <section class="pdf-item container">
          <div class="bg-white rounded p-4 mt-4 border border-light" v-if="dadosPacote.descPacote">
            <div class="row">
              <div class="col-4">
                <div class="rel-title">PACOTE</div>
                <div class="rel-value-reg">{{ dadosPacote.descPacote }}</div>
              </div>
              <div class="col-4">
                <div class="rel-title">Valor</div>
                <div class="rel-value-reg">
                  {{ 'dadosPacote.valorPacote.VLRAPLIC | currency' }}
                </div>
              </div>
            </div>
          </div>
          <div class="bg-vida rounded p-4 mt-4 border border-light">
            <div class="row align-items-center">
              <div class="col-md-3 rel-value">Detalhes do Boleto</div>
              <div class="col text-right">
                <div class="rel-value">
                </div>
              </div>
            </div>
          </div>
          <!--ExtratoFatura-->
          <Lista class="bg-white rounded pt-3 px-3 w-100" :items="this.itens" />

          <!--AjustePacote-->
          <ListaPacote class="bg-white rounded pt-3 px-3 w-100" :items="this.items" v-if="this.items.length > 0 && this.items[0].vlraplic > 0" />

          <!--VlrAplicacaoNotaFacob-->
          <ListaVlrAplicacao v-if="itensVlrAplicacaoNotaFacob.length > 0 && itensVlrAplicacaoNotaFacob[0].vlraplic > 0" class="bg-white rounded pt-3 px-3 w-100"
            :items="this.itensVlrAplicacaoNotaFacob" />

          <div class="bg-vida rounded p-4 mt-4 border border-light" v-if="itensDescontoGeral.length > 0 && itensDescontoGeral[0].vlrtotaldesconto > 0">
            <div class="row align-items-center">
              <div class="col-md-6 rel-value">Desconto Geral da Nota</div>
              <div class="col text-right">
                <div class="rel-value">
                </div>
              </div>
            </div>
          </div>
          <ListaEstorno v-if="itensDescontoGeral.length > 0 && itensDescontoGeral[0].vlrtotaldesconto > 0" class="bg-white rounded pt-3 px-3 w-100"
                        :items="this.itensDescontoGeral" />

            
          <ListaCredGeralNota v-if="itensCredGeralNota.length > 0 && itensCredGeralNota[0].valor > 0" class="bg-white rounded pt-3 px-3 w-100"
            :items="this.itensCredGeralNota" />

          <div class="bg-vida rounded p-4 mt-4 border border-light">
            <div class="row align-items-center">
              <div class="col-md-3 rel-value">VALOR TOTAL</div>
              <div class="col text-right">
                <div class="rel-value">
                  {{ totalFatura | currency }}
                </div>
              </div>
            </div>
          </div>

        </section>
        <div class="row mt-4 flex-column-reverse flex-md-row">
          <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
            <Botao title="Voltar" @click="detalhe = false" nameClass="btn btn-outline-secondary btn-lg btn-block">VOLTAR
            </Botao>
          </div>
        </div>
      </div>
      <div class="col-12" v-else>
        <div class="faturas-toolbar d-flex flex-wrap justify-content-between align-items-center mb-4">
          <div class="faturas-abas" role="tablist" aria-label="Tipo de fatura">
            <button v-for="grupo in gruposFaturas" :key="'aba-' + grupo.id" type="button" role="tab"
              class="faturas-aba" :class="{ ativa: abaAtiva === grupo.id }"
              :aria-selected="abaAtiva === grupo.id ? 'true' : 'false'" :aria-controls="grupo.id + '-painel'"
              @click="selecionarAba(grupo)">
              <span class="material-icons" aria-hidden="true">{{ grupo.pagas ? 'task_alt' : 'receipt_long' }}</span>
              {{ grupo.titulo }}
              <span class="faturas-aba-contador" v-if="!grupo.carregando && !grupo.erro">{{ grupo.faturas.length }}</span>
            </button>
          </div>
        </div>
        <section v-for="grupo in gruposFaturas" v-show="abaAtiva === grupo.id" :key="grupo.id" :id="grupo.id + '-painel'" role="tabpanel" class="faturas-secao mb-5" :aria-labelledby="grupo.id">
          <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
            <div>
              <h2 :id="grupo.id" class="faturas-titulo">{{ grupo.titulo }}</h2>
              <p class="faturas-descricao text-muted mb-0">{{ grupo.descricao }}</p>
            </div>
          </div>
          <div v-if="grupo.carregando" role="status" aria-live="polite">
            <loading />
            <span class="sr-only">Carregando {{ grupo.titulo.toLowerCase() }}...</span>
          </div>
          <div v-else-if="grupo.erro" class="alert alert-danger" role="alert">
            <p>{{ grupo.erro }}</p>
            <button type="button" class="btn btn-outline-danger btn-sm" @click="carregarFaturas(grupo.pagas)">Tentar novamente</button>
          </div>
          <div v-else-if="!grupo.faturas.length" class="bg-white rounded p-4">{{ grupo.vazio }}</div>
          <div v-else class="row">
            <div class="col-md-6 col-xl-4 mb-3" v-for="(boleto, index) in grupo.faturas" :key="grupo.id + '-' + boleto.nota + '-' + index">
              <article class="card card_content p-3 h-100">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <span class="material-icons" aria-hidden="true">receipt</span>
                  <span class="badge" :class="grupo.pagas ? 'badge-success' : 'badge-warning'">{{ grupo.pagas ? 'Paga' : 'Em aberto' }}</span>
                </div>
                <div>
                  <h3 class="h6 font-weight-bold">{{ grupo.pagas ? 'Valor pago' : 'Fatura ' + boleto.nota }}</h3>
                  <p v-if="!grupo.pagas || boleto.valor_pago != null" class="h4 mb-3">{{ (grupo.pagas ? boleto.valor_pago : boleto.valor_total) | currency }}</p>
                  <p v-else class="text-muted mb-3">Valor pago não informado</p>
                  <p v-if="grupo.pagas" class="small mb-1">Fatura: {{ boleto.nota }}</p>
                  <p class="small mb-1">Vencimento: {{ boleto.data_vencimento }}</p>
                  <p v-if="grupo.pagas" class="small mb-3">Pagamento: {{ boleto.data_liquidacao }}</p>
                </div>
                <div class="d-flex flex-wrap faturas-acoes mt-3">
                  <button v-if="grupo.pagas || Number(boleto.codsituacao) !== 1" type="button" class="btn btn-outline-primary btn-sm" @click="buscarDetalhe(boleto.nota, boleto.valor_total)">Detalhe da fatura</button>
                  <template v-if="!grupo.pagas">
                    <span v-if="Number(boleto.codsituacao) === 1" class="small text-danger">Entre em contato com nossos canais de atendimento.</span>
                    <span v-else-if="boleto.tipo_pg == '1'" class="small text-muted">Débito automático</span>
                    <a v-else-if="boleto.nossonumerosicoob && boleto.documento" :href="segundaVia(boleto)" class="btn btn-primary btn-sm" target="_blank" rel="noopener noreferrer">Emitir 2ª via</a>
                  </template>
                </div>
              </article>
            </div>
          </div>
        </section>
      </div>
    </transition>
  </fragment>
</template>

<script>
import Botao from "@/components/botoes/Botao";
import Lista from "@/components/relatorio/ExtratoFatura";
import ListaPacote from "@/components/relatorio/ExtratoFaturaPacote";
import ListaEstorno from "@/components/relatorio/ExtratoFaturaEstorno";
import ListaVlrAplicacao from "@/components/relatorio/ExtratoFaturaVlrAplicacao";
import ListaCredGeralNota from "@/components/relatorio/ExtratoListaCredGeralNota";

export default {
  name: "Boleto",
  components: { Botao, Lista, ListaPacote, ListaVlrAplicacao, ListaCredGeralNota, ListaEstorno },
  data() {
    return {
      boletos: [],
      faturasPagas: [],
      carregandoAbertas: true,
      carregandoPagas: true,
      erroAbertas: "",
      erroPagas: "",
      nNota: null,
      produto: {
        nome: "Boleto e Fatura",
        id: "2 via boleto",
      },
      breadcrumb: [
        {
          nome: "Boleto e Fatura",
          id: "2viaboleto",
        },
      ],
      nota: null,
      detalhe: false,
      abaAtiva: "faturas-abertas",
      itens: [],
      items: [],
      itensPacote: [],
      itensDescontoGeral: [],
      itensVlrAplicacaoNotaFacob: [],
      itensCredGeralNota: [],
      totalFatura: 0,
      totalAjustePacote: 0,
      totalItem: 0,
      dadosPacote: {},
      totalVlrTotalAplic: 0
    };
  },
  computed: {
    gruposFaturas() {
      return [
        { id: "faturas-abertas", titulo: "Faturas em aberto", descricao: "Consulte suas pendências e emita a segunda via do boleto.", faturas: this.boletos, carregando: this.carregandoAbertas, erro: this.erroAbertas, pagas: false, vazio: "Você não possui faturas em aberto." },
        { id: "faturas-pagas", titulo: "Últimos pagamentos", descricao: "Valores pagos nas 12 últimas faturas quitadas, por data de pagamento.", faturas: this.faturasPagas, carregando: this.carregandoPagas, erro: this.erroPagas, pagas: true, vazio: "Nenhum pagamento encontrado." },
      ];
    },
  },
  mounted() {
    // console.log("A");
    this.itens = [];
  },
  methods: {
    selecionarAba(grupo) {
      this.abaAtiva = grupo.id;
      if (!grupo.carregando) {
        return this.carregarFaturas(grupo.pagas);
      }
    },
    atualizarFaturas() {
      return Promise.all([this.carregarFaturas(), this.carregarFaturas(true)]);
    },
    async carregarFaturas(pagas = false) {
      const carregando = pagas ? "carregandoPagas" : "carregandoAbertas";
      const erro = pagas ? "erroPagas" : "erroAbertas";
      this[carregando] = true;
      this[erro] = "";
      try {
        const endpoint = pagas ? "/api/CdlBh/ListarFaturasPagas" : "/api/CdlBh/ListarFaturas";
        const response = await this.$http.get(`${endpoint}?atualizacao=${Date.now()}`);
        if (!Array.isArray(response.data)) throw new Error("Resposta inválida ao consultar faturas.");
        const faturas = response.data.map(item => Object.keys(item).reduce((normalizado, chave) => {
          normalizado[chave.toLowerCase()] = item[chave];
          return normalizado;
        }, {})).filter(item => item.nota && item.data_vencimento);
        if (pagas) this.faturasPagas = faturas.slice(0, 12);
        else this.boletos = faturas;
      } catch (error) {
        this[erro] = pagas ? "Não foi possível carregar o histórico de faturas pagas." : "Não foi possível carregar as faturas em aberto.";
        this.handleErrors(error);
      } finally {
        this[carregando] = false;
      }
    },
    segundaVia(boleto) {
      return "https://www.sicoob.com.br/web/sicoob/segunda-via-de-boleto?p_p_id=br_com_sicoob_portal_portlets_boletos_EmiteSegundaViaBoletoPortlet&p_p_lifecycle=0&p_p_state=normal&p_p_mode=view&_br_com_sicoob_portal_portlets_boletos_EmiteSegundaViaBoletoPortlet_cooperativaCliente=4030%2F129194&_br_com_sicoob_portal_portlets_boletos_EmiteSegundaViaBoletoPortlet_nossoNumero=" + encodeURIComponent(boleto.nossonumerosicoob) + "&_br_com_sicoob_portal_portlets_boletos_EmiteSegundaViaBoletoPortlet_cpfCnpjPag=" + encodeURIComponent(boleto.documento);
    },
    buscarDetalhe(nota, valorFatura) {
      this.itens = [];
      this.items = [];
      this.nNota = nota;
      this.totalFatura = 0;
      this.totalFatura = valorFatura;
      this.fetchData();
    },
    async fetchData() {
      try {
        await Promise.all([
          this.fetchExtratoFatura(),
          this.fetchAjustePacote(),
          this.fetchDescontoGeralNota(),
          this.fetchVlrAplicacaoNotaFacob(),
          this.fetchCredGeralNota(),
        ]);
      } catch (error) {
        this.handleErrors(error);
      }
    },
    async fetchExtratoFatura() {
      const response = await this.$http.get(`api/CdlBh/ExtratoFatura?numeroNota=${this.nNota}`);
      this.detalhe = true;
      this.itens = response.data;
    },
    async fetchAjustePacote() {
      const response = await this.$http.get(`api/CdlBh/AjustePacote?numeroNota=${this.nNota}`);
      this.items = [];
      this.items.push(...response.data);
    },
    async fetchDescontoGeralNota() {
      const response = await this.$http.get(`api/CdlBh/DescontoGeralNota?numeroNota=${this.nNota}`);
      this.itensDescontoGeral = [];
      this.itensDescontoGeral = [...response.data];
    },
    async fetchVlrAplicacaoNotaFacob() {
      const response = await this.$http.get(`api/CdlBh/VlrAplicacaoNotaFacob?numeroNota=${this.nNota}`);
      this.itensVlrAplicacaoNotaFacob = [];
      this.itensVlrAplicacaoNotaFacob = [...response.data];
    },
    async fetchCredGeralNota() {
      const response = await this.$http.get(`api/CdlBh/CredGeralNota?numeroNota=${this.nNota}`);
      this.itensCredGeralNota = [];
      this.itensCredGeralNota = [...response.data];
    },
    handleErrors(error) {
      if (error.response && error.response.status === 401) {
        this.$router.push({ name: "login" });
      } else {
        console.error('Error occurred:', error);
      }
    }
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.atualizarFaturas();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_vars.scss";

.card_content {
  min-height: 170px;
  display: flex;
  justify-content: space-between;
  border: 1px solid #e3e6f0;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

  small {
    line-height: 1.5rem;
  }

  &:hover,
  &:focus-within {
    transform: translateY(-4px);
    border-color: $primary;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    &:hover,
    &:focus-within {
      transform: none;
    }
  }
}

.faturas-titulo {
  color: $primary;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 8px;
}

.faturas-descricao {
  line-height: 1.5;
}

.faturas-toolbar {
  gap: 12px;
}

.faturas-abas {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 4px;
  background: #fff;
  border: 1px solid #e3e6f0;
  border-radius: 8px;
}

.faturas-aba {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: $primary;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;

  .material-icons {
    font-size: 20px;
  }

  &:hover {
    background: #eef1f8;
  }

  &:focus-visible {
    outline: 2px solid $primary;
    outline-offset: 2px;
  }

  &.ativa {
    background: $primary;
    color: #fff;

    .faturas-aba-contador {
      background: #fff;
      color: $primary;
    }
  }
}

.faturas-aba-contador {
  min-width: 22px;
  padding: 1px 7px;
  border-radius: 11px;
  background: $primary;
  color: #fff;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
}

.faturas-acoes {
  gap: 8px;
  align-items: center;
}

.bg-vida {
  background-color: #e3e6f0;
}

.title {
  color: $primary;
  font-weight: 700;
  font-size: 24px;
  text-align: center;
}

.rel-value {
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
  color: #000;
}

.rel-title {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 10px;
}

.rel-value-reg {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}

.btn-voltar {
  color: $primary;
  font-weight: 700;
  font-size: 20px;
  display: inline-flex;
  align-items: center;
}
</style>
